    import React, { useState, useEffect } from 'react';
import useAsync from '../hooks/useAsync';
import PlanServices from '../services/PlanServices';
import TogalButtonForStatus from './TogelButton/TogalButtonForStatus';
import Modal from 'react-modal';
import DeleteButton from './Button/DeleteButton';
import PlanUpdate from './Update Model/UpdatePlan';
import { Link } from 'react-router-dom';
import * as XLSX from 'xlsx';
Modal.setAppElement('#root');
function Plan() {
    const { data, error, isLoading, run } = useAsync(PlanServices.getPlan);
    const count = data?.data?.length;
    const [activeIndex, setActiveIndex] = useState(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedEdit, setSelectedEdit] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState(data?.data || []);
    useEffect(() => {
        if (data?.data) {
            setFilteredData(
                data.data.filter(plan => {
                    const planName = plan.planName?.toLowerCase() || "";
                    const mainAmount = String(plan.mainAmount ?? "").toLowerCase();
                    const offerPrice = String(plan.offerPrice ?? "").toLowerCase();
    
                    return (
                        planName.includes(searchTerm.toLowerCase()) ||
                        mainAmount.includes(searchTerm.toLowerCase()) ||
                        offerPrice.includes(searchTerm.toLowerCase())
                    );
                })
            );
        }
    }, [data, searchTerm]);
    
    const handleEditDetails = (help) => {
        setSelectedEdit(help);
        setIsEditModalOpen(true);
        toggleActionMenu(null);
    };
    const handleDelete = (help) => {
        setSelectedEdit(help);
        setIsDeleteModalOpen(true);
        toggleActionMenu(null);
    };
    const closeEditModal = () => {
        setIsEditModalOpen(false);
        setSelectedEdit(null);
    };

    const closeDeleteModal = () => {
        setIsDeleteModalOpen(false);
        setSelectedEdit(null);
    };

    const toggleActionMenu = (index) => {
        setActiveIndex(index === activeIndex ? null : index); // Toggle the active index
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };


    const formatDateTime = (isoString) => {
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with leading zero if needed
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-11) and pad with leading zero
        const year = date.getFullYear(); // Get full year
        return `${day}-${month}-${year}`; // Format as DD-MM-YYYY
    };
    const generateExcel = () => {
        // Map over the filtered data and create an array of objects for Excel
        const dataToExport = filteredData.map((plan) => ({
            planName: plan?.planName,
            price: plan?.mainAmount,
            offerprice: plan?.offerPrice,
            additionalOffer: plan?.additionalOffer,
            upgradeOffer:plan?.upgradeOffer,
            startdate:formatDateTime(plan?.startDate),
            enddate:formatDateTime(plan?.endDate),
            status: plan?.status,
        }));

        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'plans');
        XLSX.writeFile(wb, 'plans_data.xlsx');
    };


    function truncateText(text, limit) {
        const words = text.split(' ');
        if (words.length > limit) {
            return words.slice(0, limit).join(' ') + '...';
        }
        return text;
    }

    return (
        <>
            <div className="right_col" role="main">
                   <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">
                        
                                  <div className="my-auto">
                        
                                    <h5 className="page-title fs-21 mb-1">
                                    Plan Manager List        </h5>
                                    <nav>
                        
                                      <ol className="breadcrumb mb-0">
                        
                                        <li className="breadcrumb-item">
                                          <a href="javascript:void(0);">Home</a>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                        Plan Manager
                                        </li>
                                      </ol>
                                    </nav>
                                  </div>
                                  <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
                                  <Link className="round-add-btn" to="/add-plan"><img src="img/plus.svg" alt="" /></Link>
                        <button className="excel-btn" onClick={generateExcel}>
                            <img src="img/excel.svg" alt="Download Excel" />
                            Download
                        </button>      
                                  </div>
                                </div>
               


                <div className="container-box px-0">
                <div className="Tablesearch_design">
                        <div className="row">
                            <div className="col-sm-6">
                                <div className='d-flex align-items-center justify-content-between gap-2'>
                                    <div className=' w-100'>
                                        <input
                                            type="search"
                                            name="search"
                                            placeholder="Search by Plan"
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                            className='form-control'
                                        />
                                    </div>
                                    <div>
                                        <button className="search-btn">Search</button>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                    
                    <div className="container-box-inner table-reponsive-tabe">
                        <table id="example" className="table table-striped" style={{ width: '100%' }}>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>PLAN NAME</th>
                                    <th>PlanType</th>
                                    <th>MAIN PRICE</th>
                                    <th> DURATION</th>
                                    {/* <th>OFFER PRICE</th> */}
                                    {/* <th>ADDITIONAL OFFER</th> */}
                                    {/* <th>UPGRADE OFFER</th> */}
                                    {/* <th>START DATE</th>
                                    <th>END DATE</th> */}
                                    <th>STATUS</th>
                                    <th>ACTION</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.map((plan, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{plan?.planName}</td>
                                        <td>{plan?.planType}</td>
                                        <td>{plan?.mainAmount}</td>
                                        <td>{plan?.noOfMonth}</td>
                                        {/* <td>{plan?.offerPrice}</td> */}
                                        {/* <td>{plan?.additionalOffer}</td> */}
                                        {/* <td>{plan?.upgradeOffer}</td>
                                        <td>{formatDateTime(plan?.startDate)}</td>
                                        <td>{formatDateTime(plan?.endDate)}</td> */}
                                        <td className="status-toggle">
                                            <TogalButtonForStatus data={plan} page="plan" onSuccess={() => run()} />
                                        </td>
                                        {/* <td>
                                        <button className="reject" onClick={() => handleDelete(plan)}>Delete</button>
                                        </td> */}
                                        <td>
                                            <div className="action_toggle_outer">
                                                <button
                                                    className="action_toggle"
                                                    onClick={() => toggleActionMenu(index)}
                                                >
                                                    <i className="fa fa-ellipsis-v" />
                                                </button>
                                                {activeIndex === index && (
                                                    <div className="action_toggle_content product-edit show d-block">
                                                        <ul className="list-unstyled">
                                                            <li><button className="close_toggle" onClick={() => toggleActionMenu(null)}><i className="fa fa-close" /></button></li>
                                                            <li><button className="edit" onClick={() => handleEditDetails(plan)}>Edit</button></li>
                                                            <li><button className="reject" onClick={() => handleDelete(plan)}>Delete</button></li>
                                                        </ul>
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <Modal
                    isOpen={isEditModalOpen}
                    onRequestClose={closeEditModal}
                    contentLabel="User Details"
                    className="modal-content"
                    overlayClassName="modal-overlay"
                >
                    <PlanUpdate plan={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
                </Modal>
                <Modal
                    isOpen={isDeleteModalOpen}
                    onRequestClose={closeDeleteModal}
                    contentLabel="Delete Confirmation"
                    className="modal-content"
                    overlayClassName="modal-overlay"
                >
                    <DeleteButton data={selectedEdit} page="plan" closeModal={closeDeleteModal} onSuccess={run} />
                </Modal>
            </div>
        </>
    );
}

export default Plan;
